import { render, staticRenderFns } from "./lazyblock_last_recipes.vue?vue&type=template&id=cac5c4da&scoped=true"
import script from "./lazyblock_last_recipes.vue?vue&type=script&lang=js"
export * from "./lazyblock_last_recipes.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_last_recipes.vue?vue&type=style&index=0&id=cac5c4da&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_last_recipes.vue?vue&type=style&index=1&id=cac5c4da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac5c4da",
  null
  
)

export default component.exports